import { FeatureFlags } from '../../../../components/Authorizer';
import { CodeStatuses } from '../../../../constants/codes';
import { jobSearch } from '../../../../redux/modules/jobSearch';

const quickFilters = [
  {
    name: 'departmentName',
    searchKey: 'department.id',
    data: [],
    selected: [],
    pageInfo: null,
    placeholder: 'Department Name',
    idKey: 'departmentId',
    labelKey: 'departmentName'
  },
  {
    name: 'jobName',
    searchKey: 'job.id',
    data: [],
    selected: [],
    pageInfo: null,
    placeholder: 'Project Name',
    idKey: 'id',
    labelKey: 'name',
    searchBlueprint: jobSearch
  },
  {
    name: 'jobNumber',
    searchKey: 'job.id',
    data: [],
    selected: [],
    pageInfo: null,
    placeholder: 'Project Number',
    idKey: 'id',
    labelKey: 'number',
    searchBlueprint: jobSearch,
    transformFunction: data => data.filter(job => job.number !== '')
  },
  {
    name: 'codeApplied',
    nestedPath: 'item.codes',
    searchKey: 'item.codes.id',
    data: [],
    selected: [],
    pageInfo: null,
    flag: FeatureFlags.Codes,
    placeholder: 'Code Applied',
    idKey: 'id',
    labelKey: 'letter'
  },
  {
    name: 'codeStatus',
    nestedPath: 'item.codes',
    searchKey: 'item.codes.status.keyword',
    flag: FeatureFlags.Codes,
    data: [
      { status: CodeStatuses.Applied, label: CodeStatuses.Applied },
      { status: CodeStatuses.Suggested, label: `${CodeStatuses.Suggested} (+)` },
      { status: CodeStatuses.Waived, label: `${CodeStatuses.Waived} (italicized)` },
      { status: CodeStatuses.Inquiring, label: `${CodeStatuses.Inquiring}/Exception (*)` },
      { status: CodeStatuses.RemovalSuggested, label: 'removal suggested (-)' }
    ],
    selected: [],
    pageInfo: null,
    placeholder: 'Code Status',
    idKey: 'status',
    labelKey: 'label'
  }
];

export default quickFilters;
